module.exports = __webpack_public_path__ + "static/img/kescilab.a6be055.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kescilab.svg
// module id = upnz
// module chunks = 0